<div class="mobile-header-container"
     *ngIf="menuService.getMobileStyle() !== 'none'"
     [style.display]="styleDisplay"
>
  <div class="mobile-header-top"></div>
  <div
    class="mobile-header-bottom"
    [style]="headerStyle"
  >
    <div
      class="mobile-header-icon"
      style="padding-top: 20px"
      [class.active]="getClassActive('destinations')"
      (click)="onClick('destinations')"
    >
      <app-icon [icon]="Icons.newAir" [invert]="!invert"/>
    </div>
    <div class="mobile-header-icon" [class.active]="getClassActive('services')" (click)="onClick('meal')">
      <app-icon [icon]="Icons.meal" [invert]="!invert"/>
    </div>
    <div class="mobile-header-icon" [class.active]="getClassActive('feedback')" (click)="onClick('feedback')">
      <app-icon [icon]="Icons.email" [invert]="invert"/>
    </div>
    <div
      class="mobile-header-icon"
      [class.active]="menuService.getMobileActive()"
      (click)="onClick('menu')"
    >
      <app-icon [icon]="Icons.hamburger" [invert]="invert"/>
    </div>
  </div>
</div>
